import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import PageHeader from './PageHeader';
import { Link } from 'react-router-dom';

const TermsPage = () => {
    const { getFullTranslation } = useLanguage();
    const t = getFullTranslation('termsPage');

    const sections = [
        { id: '1', title: t.s1, content: [t.s1p1, t.s1p2] },
        { id: '2', title: t.s2, content: [t.s2p1], list: [t.s2i1, t.s2i2, t.s2i3, t.s2i4], after: t.s2p2 },
        { id: '3', title: t.s3, content: [t.s3p1], list: [t.s3i1, t.s3i2, t.s3i3, t.s3i4], after: t.s3p2 },
        { id: '4', title: t.s4, content: [t.s4p1], list: [t.s4i1, t.s4i2, t.s4i3, t.s4i4, t.s4i5, t.s4i6], after: t.s4p2 },
        { id: '5', title: t.s5, content: [t.s5p1, t.s5p2, t.s5p3] },
        { id: '6', title: t.s6, content: [t.s6p1], list: [t.s6i1, t.s6i2, t.s6i3, t.s6i4], after: t.s6p2, afterMore: [t.s6p3], note: t.s6note },
        { id: '7', title: t.s7, content: [t.s7p1], list: [t.s7i1, t.s7i2, t.s7i3, t.s7i4], after: t.s7p2 },
        { id: '8', title: t.s8, content: [t.s8p1], list: [t.s8i1, t.s8i2, t.s8i3, t.s8i4], after: t.s8p2 },
        { id: '9', title: t.s9, content: [t.s9p1, t.s9p2] },
        { id: '10', title: t.s10, content: [t.s10p1, t.s10p2] },
        { id: '11', title: t.s11, content: [t.s11p1] },
    ];

    const tocItems = sections.map(s => ({ id: s.id, title: s.title }));

    return (
        <div>
            <PageHeader title={t.title} subtitle={t.date} />

            <div className="max-w-3xl mx-auto px-6 py-10 pb-20">
                {/* TOC */}
                <div className="bg-orange-50 border border-orange-200 rounded-lg p-5 mb-8">
                    <h3 className="text-orange-600 font-semibold mb-3">{t.toc}</h3>
                    <ul className="space-y-2 pl-5 list-disc">
                        {tocItems.map(item => (
                            <li key={item.id}>
                                <a href={`#s${item.id}`} className="text-orange-600 hover:underline text-sm">{item.title}</a>
                            </li>
                        ))}
                    </ul>
                </div>

                <p className="text-gray-600 text-[15px] leading-relaxed mb-6">{t.intro}</p>

                {sections.map(section => (
                    <div key={section.id} id={`s${section.id}`}>
                        <h2 className="text-xl font-bold text-orange-600 mt-8 mb-3 pb-2 border-b-2 border-orange-200">{section.title}</h2>
                        {section.content?.map((p, i) => (
                            <p key={i} className="text-gray-600 text-[15px] leading-relaxed mb-3">{p}</p>
                        ))}
                        {section.list && (
                            <ul className="pl-5 space-y-2 mb-3">
                                {section.list.map((item, i) => (
                                    <li key={i} className="text-gray-600 text-[15px] list-disc">{item}</li>
                                ))}
                            </ul>
                        )}
                        {section.after && <p className="text-gray-600 text-[15px] leading-relaxed mb-3">{section.after}</p>}
                        {section.afterMore?.map((p, i) => (
                            <p key={i} className="text-gray-600 text-[15px] leading-relaxed mb-3">{p}</p>
                        ))}
                        {section.note && (
                            <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-r-lg my-4">
                                <p className="text-red-800 text-sm font-medium">{section.note}</p>
                            </div>
                        )}
                    </div>
                ))}

                <p className="mt-6 text-gray-400 text-xs">{t.footer}</p>
                <Link to="/" className="inline-block mt-8 text-orange-600 font-medium hover:underline">{t.back}</Link>
            </div>
        </div>
    );
};

export default TermsPage;
